// Styles for AccountPartnerCardWrapper go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledAccountPartnerCardWrapper = styled.div`
  .mt-5 {
    margin-top: ${toRem(8)} !important;
    @media ${baseVariables.mediaQuery.md} {
      margin-top: ${toRem(32)} !important;
    }
  }
  .mb-5 {
    margin-bottom: ${toRem(8)} !important;
    @media ${baseVariables.mediaQuery.md} {
      margin-bottom: ${toRem(32)} !important;
    }
  }

  .my-5 {
    margin-top: ${toRem(24)} !important;
    margin-bottom: ${toRem(24)} !important;
    @media ${baseVariables.mediaQuery.md} {
      margin-top: ${toRem(32)} !important;
      margin-bottom: ${toRem(32)} !important;
    }
  }
  .py-5 {
    padding-top: ${toRem(24)} !important;
    padding-bottom: ${toRem(24)} !important;
    @media ${baseVariables.mediaQuery.md} {
      padding-top: ${toRem(32)} !important;
      padding-bottom: ${toRem(32)} !important;
    }
  }

  &.m-container-fullbleed {
    .add-gutter-space-top {
      @media ${baseVariables.mediaQuery.desktop} {
        margin-top: ${toRem(16)};
      }
    }
    .add-gutter-space-bottom {
      @media ${baseVariables.mediaQuery.desktop} {
        margin-bottom: ${toRem(16)};
      }
    }
  }
`;
export const StyledAccountPartnerCardCompParent = styled.div``;
export const StyledAccountPartnerCardPublishedContainer = styled.div`
  .card_wrapper {
    padding-bottom: ${toRem(48)};
  }
`;
export const StyledAccountPartnerCardChildComponentWrapper = styled.div`
  > div {
    height: 100%;
  }
  .m-account-card {
    box-shadow: rgba(0, 0, 0, 0.07) ${toRem(0)} ${toRem(4)} ${toRem(20)} ${toRem(0)};
    border-radius: ${toRem(10)};
    box-sizing: border-box;
    padding: ${toRem(32)} ${toRem(24)};
    height: 100%;
  }
  .card-vertical_chevron {
    &:before {
      font-size: ${toRem(20)};
    }
  }
  &.glide__slide {
    height: auto;
  }
`;
export const StyledAccountPartnerCardHeaderWrapper = styled.div``;
